import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Grid,
  Icon,
  Loader,
  Modal,
  Segment,

} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import config from '../../../config';

import Timestamp from '../../components/Timestamp';
import ViewLarge from '../modals/ViewLarge';
import fileSize from '../../utils/fileSize';
import DeleteConfirm from '../../containers/modals/DeleteConfirm';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class AttachmentModal extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    modalState: PropTypes.bool,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const modalState = props.modalState;
    const data = Object.assign({}, props.data);
    return {
      data,
      modalState,
    };
  }
  constructor(props) {
    super(props);
    const state = AttachmentModal.getPropsToState(props);

    this.state = {
      loading: false,
      pictureListModalOpen: false,
      pictureListModalID: '',
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      showDeletePictureConfirm: false,
      deleteFile: null,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = AttachmentModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getPaymentPictures = () => {
    const { data } = this.state;
    if (data && data.paymentPictures && data.paymentPictures.length > 0) {
      return data.paymentPictures;
    }
    return [];
  }
  checkDisabled(direction = 'right') {
    const { selectedPicture } = this.state;
    if (this.getPaymentPictures() && this.getPaymentPictures().length > 0 && selectedPicture) {
      const index = this.getPaymentPictures().indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < this.getPaymentPictures().length;
    }
    return false;
  }
  handleClosePictureListModal = () => {
    if (this.props.onClose) this.props.onClose();
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
    });
  }
  handleCancelDeletePicture = (e) => {
    e.preventDefault();
    this.setState({
      showDeletePictureConfirm: false,
      deleteFile: null,
    });
  }
  handleConfirmDeletePicture = (e) => {
    e.preventDefault();
    const fileID = this.state.deleteFile.id;
    this.setState({
      showDeletePictureConfirm: false,
      deleteFile: null,
    }, () => {
      this.props.onDelete(fileID, this.removeDeletedPictures);
    });
  }
  handleDeletePicture = (e, file) => {
    e.preventDefault();
    this.setState({
      showDeletePictureConfirm: true,
      deleteFile: file,
    });
  }
  handleOpenAttachment = (e, file) => {
    e.preventDefault();
    const url = `${config.get('bookApiURL')}/bookings/${this.state.data.bookingID}/pictures/${file.id}/print/`;
    window.open(url);
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { selectedPicture } = this.state;
    const index = this.getPaymentPictures().indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: this.getPaymentPictures()[nextIndex],
    });
  }
  handleViewLargeSlide = (e, data) => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true,
    });
  }
  removeDeletedPictures = (picId) => {
    const { data } = this.state;
    const picIndex = data.paymentPictures.findIndex(e => e.id === picId);
    if (picIndex !== -1) {
      data.paymentPictures.splice(picIndex, 1);
      this.setState({ data });
    }
  }
  render() {
    const { t } = this.props;
    const { modalState, deleteFile } = this.state;
    return (
      <div>
        <DeleteConfirm
          open={this.state.showDeletePictureConfirm}
          onClose={this.handleCancelDeletePicture}
          onConfirm={this.handleConfirmDeletePicture}
          name={deleteFile ? deleteFile.name : ''}
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedPicture}
          onSlide={this.handleSlidePicture}
          disabledLeft={!this.checkDisabled('left')}
          disabledRight={!this.checkDisabled('right')}
          slideshow={this.state.slideshow}
        />
        <Modal
          open={modalState}
          onClose={this.handleClosePictureListModal}
        >
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Modal.Header>
            <Grid>
              <Grid.Row verticalAlign="middle">
                <Grid.Column mobile={8} tablet={8} computer={8}>
                  <h3><Icon name="attach" size="large" /> {t('Payment Attachments')}</h3>
                </Grid.Column>
                <Grid.Column mobile={8} tablet={8} computer={8} textAlign="right" />
              </Grid.Row>
            </Grid>
          </Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              <Segment.Group>
                { this.getPaymentPictures().length > 0 ?
                    this.getPaymentPictures().map((file, id) => (
                      <Segment key={id}>
                        <Grid
                          columns="equal"
                          verticalAlign="middle"
                          as="a"
                        >
                          <Grid.Column mobile={16} tablet={5} computer={6} textAlign="left" onClick={e => this.handleViewLargeSlide(e, file)} style={{ overflowX: 'hidden' }}>
                            <Icon name="file image outline" />
                            {file.name}
                            <span className="mobile-hide"> ({fileSize(file.size)})</span>
                            <small className="large-hide small-hide tablet-hide"><br />{fileSize(file.size)}</small>
                          </Grid.Column>
                          <Grid.Column mobile={16} tablet={5} computer={5} style={{ paddingLeft: 0 }}>
                            <p className="attachment-button">
                              <Button
                                basic
                                content={t('Print Attachment')}
                                onClick={e => this.handleOpenAttachment(e, file)}
                              />
                            </p>
                          </Grid.Column>
                          <Grid.Column mobile={16} tablet={6} computer={5} textAlign="right">
                            <small onClick={e => this.handleViewLargeSlide(e, file)} style={{ paddingRight: '1em' }}><Timestamp format="DD/MM/YY hh:mm a" timestamp={file.createdAt} /></small>
                            {this.props.onDelete ?
                              <Button
                                compact
                                negative
                                type="button"
                                size="tiny"
                                icon="trash"
                                onClick={e => this.handleDeletePicture(e, file)}
                              />
                              : ''}
                          </Grid.Column>
                        </Grid>
                      </Segment>
                    ))
                  : <Segment textAlign="center">No pictures found</Segment>
                }
              </Segment.Group>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleClosePictureListModal} content={t('Close', { ns: TRANSLATION_FILES.translation })} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default withTranslation(namespaces)(AttachmentModal);



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/AttachmentModal.jsx